import auth, { ACTIVE_SYSTEM_LOCAL_STORAGE_KEY } from 'store/auth/auth'
import { NAVBAR_WIDTH, NAVBAR_WIDTH_NARROW } from 'styles/variables'

import { proxy, snapshot } from 'valtio'
import { subscribeKey } from 'valtio/utils'

type GlobalStore = {
  navigationIsOpen: boolean
  navigationMobileOpen: boolean
  notificationCenterIsOpen: boolean
  windowWidth: number
  windowHeight: number
  systemShortcut: boolean
  bodyWidth: number
  cardWidth: number
  moduleBodyWidth: number
  moduleCardWidth: number
  moduleContentInCardWidth: number
}

const RESIZE_BOUNCE_DELAY = 400

let resizeStartTime = 0
let isResizing = false

window.onresize = () => {
  resizeStartTime = +new Date()

  if (isResizing) {
    return
  }

  isResizing = true
  setTimeout(resizeEnded, RESIZE_BOUNCE_DELAY)
}

function resizeEnded(): void {
  if (+new Date() - resizeStartTime < RESIZE_BOUNCE_DELAY) {
    setTimeout(resizeEnded, RESIZE_BOUNCE_DELAY)
  } else {
    isResizing = false
    globalStore.windowWidth = window.innerWidth
    globalStore.windowHeight = window.innerHeight
  }
}

const globalStore = proxy<GlobalStore>({
  navigationIsOpen: localStorage.getItem(`navigationIsOpen`) !== `false`,
  navigationMobileOpen: false,
  notificationCenterIsOpen: false,
  windowWidth: window.innerWidth,
  windowHeight: window.innerHeight,
  systemShortcut: localStorage.getItem('systemShortcut') === 'true',
  get bodyWidth() {
    return this.navigationIsOpen ? this.windowWidth - NAVBAR_WIDTH : this.windowWidth - NAVBAR_WIDTH_NARROW
  },
  get moduleBodyWidth() {
    return this.navigationIsOpen ? this.windowWidth - NAVBAR_WIDTH : this.windowWidth - NAVBAR_WIDTH_NARROW - 10
  },
  get cardWidth() {
    return (this.navigationIsOpen ? this.windowWidth - NAVBAR_WIDTH : this.windowWidth - NAVBAR_WIDTH_NARROW) - 20
  },
  get moduleCardWidth() {
    return (this.navigationIsOpen ? this.windowWidth - NAVBAR_WIDTH : this.windowWidth - NAVBAR_WIDTH_NARROW) - 50
  },
  get moduleContentInCardWidth() {
    return (this.navigationIsOpen ? this.windowWidth - NAVBAR_WIDTH : this.windowWidth - NAVBAR_WIDTH_NARROW) - 70
  },
})

subscribeKey(globalStore, `navigationIsOpen`, (navigationIsOpen) => {
  localStorage.setItem(`navigationIsOpen`, navigationIsOpen ? `true` : `false`)
})

subscribeKey(globalStore, 'systemShortcut', (systemShortcut) => {
  localStorage.setItem('systemShortcut', systemShortcut ? 'true' : 'false')
})

window.onbeforeunload = () => {
  const authSnap = snapshot(auth)
  localStorage.setItem(ACTIVE_SYSTEM_LOCAL_STORAGE_KEY, JSON.stringify(authSnap.activeSystem))
}

export default globalStore
